import React from "react";

const ChronicConditionsContext = React.createContext({});

export default ChronicConditionsContext;
